import { render, staticRenderFns } from "./LicencaList.vue?vue&type=template&id=6066bf2e&scoped=true"
import script from "./LicencaList.vue?vue&type=script&lang=js"
export * from "./LicencaList.vue?vue&type=script&lang=js"
import style0 from "./LicencaList.vue?vue&type=style&index=0&id=6066bf2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066bf2e",
  null
  
)

export default component.exports